import { render, staticRenderFns } from "./scope13.vue?vue&type=template&id=6ab2faab&scoped=true"
import script from "./scope13.vue?vue&type=script&lang=js"
export * from "./scope13.vue?vue&type=script&lang=js"
import style0 from "./scope13.vue?vue&type=style&index=0&id=6ab2faab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab2faab",
  null
  
)

export default component.exports